import instance from "../utils/axios";
import { UserInfo } from "../@types";

export const validateSessionId = (sessionId: string) =>
  instance.get<{ data: UserInfo }>(`/authentication?wes=${sessionId}`);
